import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  YAxis,
  XAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { VoucherDashBoardAPI } from "../../Utils/Api/VouchersDashBoardAPI";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export const Graph = (props) => {
  const {
    GraphData,
    GraphData1,
    setGraphData,
    setGraphData1,
    setLoading,
    Bu_id,
  } = props;
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const navigate = useNavigate();

  const GetDateGraph = async (enddate) => {
    setLoading(true);
    let objectDate = startDate;
    if (objectDate == "") {
      toast.error("Please enter start date!", {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
      setEndDate("");
    } else {
      let day = objectDate.getDate();
      let month = objectDate.getMonth();
      let year = objectDate.getFullYear();
      const fromDate = `${year}-${month + 1}-${day}`;
      // console.log(fromDate);
      let objectDateEnd = enddate;
      let dayEnd = objectDateEnd.getDate();
      let monthEnd = objectDateEnd.getMonth();
      let yearEnd = objectDateEnd.getFullYear();
      const toDate = `${yearEnd}-${monthEnd + 1}-${dayEnd}`;
      // console.log(toDate);
      const data = {
        business_id: Bu_id,
        start_date: fromDate,
        end_date: toDate,
      };
      const coupondetailData = await VoucherDashBoardAPI(data, () => {
        navigate("/");
      });
      setLoading(false);
      if (coupondetailData.success == false) {
        toast.error(coupondetailData.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }else if (coupondetailData.status == 429) {
        setLoading(true);
        toast.error(coupondetailData.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }  else {
        setGraphData(coupondetailData.data.sales_by_date);
        setGraphData1(coupondetailData.data.sales_by_volume);
      }
    }
  };

  return (
    <Row
      className="mt-3 DateSection graph_Row"
      style={{ marginBottom: "4rem" }}
    >
      <div className="date_range">
        <div className="range_btn1">
          <p style={{ fontWeight: 700, fontSize: 16 }}>Choose Date Range</p>
          <div className="range_btn hypen-date">
            <DatePicker
              className="dateRange_btn btn btn-primary"
              id="startDate"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={endDate}
              maxDate={new Date()}
              dateFormat="dd/MM/yyyy"
              placeholderText="Start Date"
            />
            <p>-</p>
            <DatePicker
              className="dateRange_btn btn btn-primary"
              id="startDate"
              selected={endDate}
              onChange={(date) => {
                setEndDate(date);
                GetDateGraph(date);
              }}
              selectsEnd
              startDate={startDate}
              endDate={endDate}
              minDate={startDate}
              maxDate={new Date()}
              dateFormat="dd/MM/yyyy"
              placeholderText="End Date"
            />
          </div>
        </div>
      </div>
      {/* 1 */}
      <Col>
        <span style={{ fontWeight: 700, fontSize: 16, marginLeft: 5 }}>
          Sales By Value
        </span>
        <ResponsiveContainer width="90%" height={350}>
          <LineChart data={GraphData}>
            <CartesianGrid
              stroke="#c4c6c8"
              strokeDasharray="10.5"
              horizontal={true}
              vertical={false}
            />
            <XAxis dataKey="date" xAxisId={0} axisLine={false} dy={15} />
            <YAxis axisLine={false} unit="$" dx={-17} />
            <Tooltip cursor={false} width={100} height={50} />
            <Line
              type="monotone"
              dataKey="amount"
              stroke="#E66100"
              dot={false}
              strokeWidth={2}
              strokeLinecap="round"
            />
          </LineChart>
        </ResponsiveContainer>
      </Col>
      {/* 2 */}
      <Col>
        <span style={{ fontWeight: 700, fontSize: 16, marginLeft: 5 }}>
          Sales By Volume
        </span>
        <ResponsiveContainer width="90%" height={350}>
          <LineChart data={GraphData1}>
            <CartesianGrid
              stroke="#c4c6c8"
              strokeDasharray="10.5"
              horizontal={true}
              vertical={false}
            />
            <XAxis dataKey="date" xAxisId={0} axisLine={false} dy={15} />
            <YAxis axisLine={false} dx={-17} />
            <Tooltip cursor={false} width={100} height={50} />
            <Line
              type="monotone"
              dataKey="volume"
              stroke="#E66100"
              dot={false}
              strokeWidth={2}
              strokeLinecap="round"
            />
          </LineChart>
        </ResponsiveContainer>
      </Col>
    </Row>
  );
};
